import useLocalization from '../../hooks/useLocalization';
import AlertModal from '../common/AlertModal';
import { CameraVideo } from 'react-bootstrap-icons';

const RecordZoomMeetingModal = ({ show, onHide, onConfirm, progress }) => {
  const { translate } = useLocalization();

  return (
    <AlertModal
      show={show}
      onHide={onHide}
      alertText={translate('confirm_start_new_meeting')}
      continueButtonText={translate('start_meeting')}
      continueButtonVariant="success text-white"
      continueButtonSize="sm"
      onContinueClick={onConfirm}
      alertIcon={<CameraVideo className="text-masked-cell" size={30} />}
      showProgress={progress}
      progressText={translate('starting_meeting')}
    />
  );
};

export default RecordZoomMeetingModal;
